import apiClient from "../helpers/apiClient";

const deleteFile = async (url) => {
    if (!url) {
        return undefined;
    }

    try {
        const filePath = url.split("/").slice(4).join("/");

        const response = await apiClient.delete(`/api/upload/delete?filePath=${filePath}`);
        return response.data?.success || false;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error deleting file:", error);
        return false;
    }
};

export default deleteFile;
